import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M4 12.699c0-.45.365-.816.816-.816a.816.816 0 0 0 .814-.87l-.312-4.678a2.25 2.25 0 0 1 2.654-2.362L13 5l6.75.618c.984.182.631 1.325.73 2.321l.342 3.412a.59.59 0 0 0 .587.532.59.59 0 0 1 .591.59v7.285a2.25 2.25 0 0 1-2.25 2.25H6.25A2.25 2.25 0 0 1 4 19.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.175 4.4H7.429a1.6 1.6 0 0 0-1.6 1.6v5.785h-1.4V6a3 3 0 0 1 3-3h1.746a3 3 0 0 1 1.754.566l.333.24a3 3 0 0 0 1.755.567h5.555a3 3 0 0 1 3 3v4.412h-1.4V7.373a1.6 1.6 0 0 0-1.6-1.6h-5.555a4.4 4.4 0 0 1-2.573-.83l-.334-.24a1.6 1.6 0 0 0-.935-.303"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.175 7.562H7.429a1.6 1.6 0 0 0-1.6 1.6v2.616h-1.4V9.162a3 3 0 0 1 3-3h1.746a3 3 0 0 1 1.754.567l.333.24a3 3 0 0 0 1.754.566h5.556a3 3 0 0 1 3 3v1.15h-1.4v-1.15a1.6 1.6 0 0 0-1.6-1.6h-5.556a4.4 4.4 0 0 1-2.572-.83l-.334-.24a1.6 1.6 0 0 0-.935-.303"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.5 11.986h-13a2.1 2.1 0 0 0-2.1 2.1V19.5c0 1.16.94 2.1 2.1 2.1h13a2.1 2.1 0 0 0 2.1-2.1v-5.414a2.1 2.1 0 0 0-2.1-2.1m-13-1.4a3.5 3.5 0 0 0-3.5 3.5V19.5A3.5 3.5 0 0 0 6.5 23h13a3.5 3.5 0 0 0 3.5-3.5v-5.414a3.5 3.5 0 0 0-3.5-3.5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.143 14.905c0-.526.426-.953.952-.953h3.81a.952.952 0 1 1 0 1.905h-3.81a.95.95 0 0 1-.952-.952"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=PortfolioIcon26.js.map